module.exports = __webpack_public_path__ + "img/szxnfz.79f0344a.png";